import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/DSULink/Home";

const DSULink = () => {
  return (
    <div className="Account">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default DSULink;
